var render = function render(){var _vm=this,_c=_vm._self._c;return _c('code',[_vm._v(" "+_vm._s(_vm._f("regexGroups")(_vm.number,/(\d{6})(\d{4})(\d+)/))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }